import { Check } from "lucide-react";

export const isSubmitted = (a) => (a.status === "submitted" || a.status === "reviewed") && !a.resubmit_needed;

export const portalProgress = (req, visited, tabs, submitted) => {
  if (submitted) return 100;
  const total = req.all.size || 1;
  const filled = total - req.list.length;
  const seen = tabs.filter(([k]) => visited.includes(k)).length;
  return Math.min(95, Math.round((70 * filled) / total + (25 * seen) / tabs.length));
};

export const tabDone = (k, req, visited, submitted) => (k === "summary" ? submitted : visited.includes(k) && !req.list.some((m) => m.tab === k));

export const ProgressSteps = ({ tabs, tab, pct, done, onGo }) => {
  const i = tabs.findIndex(([k]) => k === tab);
  return (
    <section className="progress-card" data-testid="portal-progress">
      <div className="flex items-baseline justify-between gap-3">
        <p className="text-sm font-semibold text-[#0b2545]" data-testid="portal-progress-step">Step {i + 1} of {tabs.length} · <span className="text-[#0072C6]">{tabs[i][2].split(" · ")[1]}</span></p>
        <p className="font-mono text-sm font-bold text-[#0b2545]" data-testid="portal-progress-percent">{pct}% complete</p>
      </div>
      <div className="progress-track" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}><div className="progress-fill" style={{ width: `${pct}%` }} data-testid="portal-progress-fill" /></div>
      <ol className="progress-steps">
        {tabs.map(([k, , short], j) => (
          <li key={k}>
            <button type="button" onClick={() => onGo(k)} data-testid={`progress-step-${k}`} className={`progress-step ${k === tab ? "is-current" : ""} ${done(k) ? "is-done" : ""}`}>
              <span className="progress-dot">{done(k) ? <Check className="h-3.5 w-3.5" /> : j + 1}</span>
              <span className="progress-label">{short.split(" · ")[1]}</span>
            </button>
          </li>
        ))}
      </ol>
      {pct < 100 && <p className="text-[11px] text-slate-500 mt-1">{pct >= 95 ? "Everything's ready. Submit to your advisor to finish." : "Fill in the highlighted answers and open each step. You reach 100% when you submit."}</p>}
    </section>
  );
};
